export default "https://cdn-static-staging.gokick.com/assets/fcb4ac80126f26ea915890c2472f26527471791c/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";